module.exports = "/_next/static/images/Survey-210664401a7f2b9c36e935f27eb7543f.svg";